import React, { useState } from 'react'
import { customerData } from '../../../utilities/CustomerData'

import setcCheckMark from '../../../assets/DashboardIcons/DashboardStageHistoryIcons/setcCheckMark.png'
import infoIcon from '../../../assets/DashboardIcons/DashboardStageHistoryIcons/infoIcon.png'

export default function DashboardStageHistory() {
  const currentStageIndex = customerData.customerStageHistory.findIndex(stage => stage.currentStage === true)

  function MultilineText({ text, textColor }) {
    const lines = text.split('\\n')

    const renderTextWithItalics = (text) => {
      const parts = text.split(/(<i>|<\/i>|<b>|<\/b>)/)
      let isInItalic = false
      let isInBold = false

      return parts.map((part, index) => {
        if (part === "<i>") {
          isInItalic = true
          return null
        } else if (part === "</i>") {
          isInItalic = false
          return null
        } else if (part === '<b>') {
          isInBold = true
          return null
        } else if (part === '</b>') {
          isInBold = false
          return null
        } else {
          if (isInItalic && isInBold) {
            return (
              <b key={index}>
                <i>{part}</i>
              </b>
            )
          } else if (isInItalic)
            return <i key={index}>{part}</i>
          else if (isInBold)
            return <b key={index}>{part}</b>
          else
            return part
        }
      })
    }

    return (
      <div className={`text-center text-sm text-${textColor} mt-4`}>
        {lines.map((line, index) => (
          <React.Fragment key={index}>
            {renderTextWithItalics(line)}
            {index !== lines.length - 1 && <><br /><div style={{ height: '8px' }} /></>}
          </React.Fragment>
        ))}
      </div>
    )
  }

  function CurrentStageRight({ stageHistory }) {
    return (
      <div className="flex flex-row max-sm:flex-col items-center justify-center h-fit w-full mt-5 mb-5">
        <div className="max-sm:translate-y-1.5 z-20 lg:absolute w-3 h-3 bg-white rounded-full border-2 border-gray-800"></div>
        <div className='w-1/2'></div>
        <div className='p-4 max-sm:z-10 bg-primaryColor rounded-md lg:w-1/2 lg:ml-10 w-full'>
          <p className='text-white lg:text-start text-center mb-4'>{stageHistory.customerStageName}</p>
          {stageHistory.customerStageDesc.length > 0 && (
            <MultilineText text={stageHistory.customerStageDesc} textColor={'white'} />
          )}
          {stageHistory.customerStageLink && (
            <>
              <div className='h-4'></div>
              <a className='ml-[25%] underline text-blue-800' href={stageHistory.customerStageLink} target='_blank' rel='noopener noreferrer'>{stageHistory.customerStageLink}</a>
            </>
          )}
          {customerData.customerValidiFiBankVerification.accessUrl && (
            <>
              <div className='h-4'></div>
              <a className='ml-[25%] underline text-blue-800' href={customerData.customerValidiFiBankVerification.accessUrl} target='_blank' rel='noopener noreferrer'>Click me to verify bank account!</a>
            </>
          )}
        </div>
      </div>
    )
  }

  function CurrentStageLeft({ stageHistory }) {
    return (
      <div className="flex flex-row max-sm:flex-col items-center justify-center h-fit w-full mt-5 mb-5">
        <div className="max-sm:translate-y-1.5 z-20 lg:absolute w-3 h-3 bg-white rounded-full border-2 border-gray-800"></div>
        <div className='p-4 max-sm:z-10 bg-primaryColor rounded-md lg:w-1/2 lg:mr-10 w-full'>
          <p className='text-white lg:text-end text-center'>{stageHistory.customerStageName}</p>
          {stageHistory.customerStageDesc.length > 0 && (
            <MultilineText text={stageHistory.customerStageDesc} textColor={'white'} />
          )}
          {stageHistory.customerStageLink.length > 0 && (
            <>
              <div className='h-4'></div>
              <a className='ml-[25%] underline text-blue-800' href={stageHistory.customerStageLink} target='_blank' rel='noopener noreferrer'>{stageHistory.customerStageLink}</a>
            </>
          )}
          {customerData.customerValidiFiBankVerification.accessUrl && (
            <>
              <div className='h-4'></div>
              <a className='ml-[25%] underline text-blue-800' href={customerData.customerValidiFiBankVerification.accessUrl} target='_blank' rel='noopener noreferrer'>Click me to verify bank account!</a>
            </>
          )}
        </div>
        <div className='w-1/2'></div>
      </div>
    )
  }

  function LeftStage({ stageHistory, stageCleared }) {
    const [showDesc, setShowDesc] = useState(false)

    return (
      <div className="flex flex-row max-sm:flex-col items-center justify-center h-fit w-full mt-5 mb-5">
        {stageCleared ? (
          <img className='max-sm:translate-y-3 z-20 lg:absolute w-6 h-6' src={setcCheckMark} alt="Check Mark" />
        ) : (
          <div className="max-sm:translate-y-1.5 z-20 lg:absolute w-3 h-3 bg-white rounded-full border-2 border-gray-800"></div>
        )}
        <div className='p-4 max-sm:z-10 bg-gray-300 rounded-md lg:w-1/2 w-full lg:mr-10'>
          <div className='flex flex-row justify-between'>
            {stageHistory.customerStageDesc.length > 0 && (
              <img onClick={() => setShowDesc(!showDesc)} className='w-6 h-6 cursor-pointer' src={infoIcon} alt='infoIcon' />
            )}
            <p className='lg:ml-auto max-sm:w-full text-center'>{stageHistory.customerStageName}</p>
          </div>
          {showDesc && (
            <div className='mt-4'>
              <MultilineText text={stageHistory.customerStageDesc} textColor={'black'} />
              {stageHistory.customerStageLink.length > 0 && (
                <>
                  <div className='h-4'></div>
                  <a className='ml-[25%] underline text-blue-800' href={stageHistory.customerStageLink} target='_blank' rel='noopener noreferrer'>{stageHistory.customerStageLink}</a>
                </>
              )}
              {customerData.customerValidiFiBankVerification.accessUrl && (
                <>
                  <div className='h-4'></div>
                  <a className='ml-[25%] underline text-blue-800' href={customerData.customerValidiFiBankVerification.accessUrl} target='_blank' rel='noopener noreferrer'>Click me to verify bank account!</a>
                </>
              )}
            </div>
          )}
        </div>
        <div className='w-1/2'></div>
      </div>
    )
  }

  function RightStage({ stageHistory, stageCleared }) {
    const [showDesc, setShowDesc] = useState(false)

    return (
      <div className="flex flex-row max-sm:flex-col items-center justify-center h-fit w-full mt-5 mb-5">
        {stageCleared ? (
          <img className='max-sm:translate-y-3 z-20 lg:absolute pos w-6 h-6' src={setcCheckMark} alt="Check Mark" />
        ) : (
          <div className="max-sm:translate-y-1.5 z-20 lg:absolute w-3 h-3 bg-white rounded-full border-2 border-gray-800"></div>
        )}
        <div className='w-1/2'></div>
        <div className='p-4 max-sm:z-10 bg-gray-300 rounded-md lg:w-1/2 w-full lg:ml-10'>
          <div className='flex flex-row justify-between'>
            <p className='lg:text-end max-sm:w-full text-center'>{stageHistory.customerStageName}</p>
            {stageHistory.customerStageDesc.length > 0 && (
              <img onClick={() => setShowDesc(!showDesc)} className='w-6 h-6 cursor-pointer' src={infoIcon} alt='infoIcon' />
            )}
          </div>
          {showDesc && (
            <div className='mt-4'>
              <MultilineText text={stageHistory.customerStageDesc} textColor={'black'} />
              {stageHistory.customerStageLink.length > 0 && (
                <>
                  <div className='h-4'></div>
                  <a className='ml-[25%] underline text-blue-800' href={stageHistory.customerStageLink} target='_blank' rel='noopener noreferrer'>{stageHistory.customerStageLink}</a>
                </>
              )}
              {customerData.customerValidiFiBankVerification.accessUrl && (
                <>
                  <div className='h-4'></div>
                  <a className='ml-[25%] underline text-blue-800' href={customerData.customerValidiFiBankVerification.accessUrl} target='_blank' rel='noopener noreferrer'>Click me to verify bank account!</a>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    )
  }

  function SingleStage({ stageHistory }) {
    return (
      <div className="flex flex-row max-sm:flex-col items-center justify-center h-fit lg:w-1/2 w-full">
        <div className='p-4 max-sm:z-10 bg-red-700 rounded-md lg:w-full w-full'>
          <p className='text-white text-center'>{stageHistory.customerStageName}</p>
          {stageHistory.customerStageDesc.length > 0 && (
            <MultilineText text={stageHistory.customerStageDesc} textColor={'white'} />
          )}
        </div>
      </div>
    )
  }

  return (
    <div className='shadow-full rounded-xl p-4 lg:w-full w-11/12 h-fit mt-10 flex flex-col items-center bg-white mb-10'>
      <div className='relative w-full h-full flex flex-col justify-start items-center'>
        {customerData.customerStageHistory.length > 0 ? (
          <>
            <div className="absolute w-1 bg-secondaryColor h-full"></div>
            {customerData.customerStageHistory.map((stageHistory, index) => {
              if (stageHistory.currentStage) {
                return index % 2 === 0 ? (
                  <CurrentStageRight key={index} stageHistory={stageHistory} />
                ) : (
                  <CurrentStageLeft key={index} stageHistory={stageHistory} />
                )
              } else {

                const stageCleared = index < currentStageIndex
                return index % 2 === 0 ? (
                  <RightStage key={index} stageHistory={stageHistory} stageCleared={stageCleared} />
                ) : (
                  <LeftStage key={index} stageHistory={stageHistory} stageCleared={stageCleared} />
                );
              }
            })}
          </>
        ) : (
          <SingleStage stageHistory={customerData.customerStageHistory[0]} />
        )}
      </div>
    </div>
  )
}